String.prototype.parsed = function() {
   return parseInt(this)
}, window.mbCarousel = function(t, e = {}, s) {
   const n = "string" == typeof t ? document.querySelector(t) : t;
   if (!n) return;
   const i = new IntersectionObserver(((t, i) => {
       t.forEach((t => {
           t.isIntersecting && (! function(t, e = {}, s) {
               const n = t.classList.contains("flickity-enabled"),
                   i = Array.from(t.children),
                   o = document.createElement("div"),
                   c = getComputedStyle(t).width,
                   r = window.innerWidth <= 800;
               if (n) return;
               if (Array.isArray(s) ? s.forEach((e => {
                       t.classList.add(e)
                   })) : "string" == typeof s && t.classList.add(s), t.classList.contains("mb-carousel")) return;

               function l(t) {
                   const e = document.createElement("div");
                   return e.innerHTML = t, e.children[0]
               }
               if (t.classList.add("mb-carousel"), e.responsive) {
                   const t = Object.keys(e.responsive).sort(((t, e) => t < e));
                   for (let s of t)
                       if (s = s.parsed(), s >= window.innerWidth) {
                           const t = e.responsive[s.toString()];
                           e = t.inherit ? Object.assign(e, t) : t;
                           break
                       }
               }
               const a = e.items;
               if (o.classList.add("carousel-container"), i.forEach((t => {
                       const e = document.createElement("div");
                       e.classList.add("carousel-item"), e.append(t), o.append(e)
                   })), a) {
                   const t = c.parsed() / a;
                   i.forEach((e => {
                       (e = e.parentElement).style.width = `${t}px`
                   }))
               } else i.forEach((t => {
                   t.style.flex = 1
               }));
               const d = e.fullWidth ? getComputedStyle(t).width.parsed() : i[0].parentElement.style.width.parsed();

               function p(t) {
                   const e = o.scrollLeft,
                       s = t ? e + d : e - d;
                   o.scroll({
                       top: 0,
                       left: s,
                       behavior: "smooth"
                   })
               }
               if (i.length > e.items) {
                   if (e.dots) {
                       const e = Math.ceil(i.length / a);
                       if (e > 1) {
                           const s = l('\n                            <ul class="mb-carousel-dots" style="display: none">\n                            </ul>\n                        ');
                           s.style.width = getComputedStyle(t).width.parsed() - 1 + "px";
                           for (let t = 0; t < e; t++) {
                               const e = l("<li>&nbsp;</li>");
                               e.addEventListener("click", (function() {
                                   const e = document.querySelector(".mb-carousel-dots li.active");
                                   e !== this && (o.scroll({
                                       top: 0,
                                       left: d * t,
                                       behavior: "smooth"
                                   }), e.classList.remove("active"), this.classList.add("active"))
                               })), s.append(e)
                           }
                           o.addEventListener("scroll", (function() {
                               const t = this.scrollLeft,
                                   e = Math.ceil(t / c.parsed()),
                                   n = Array.from(s.children),
                                   i = n.find((t => t.classList.contains("active"))),
                                   o = n[e];
                               i !== o && (i.classList.remove("active"), o.classList.add("active"))
                           })), setTimeout((() => {
                               s.style.transform = `translateY(${getComputedStyle(t).height})`, s.style.display = "", s.children[0].classList.add("active")
                           }), 50), t.append(s)
                       }
                   }
                   if (e.buttons) {
                       const e = l('\n                    <div class="mb-carousel-buttons" style="display: none">\n                        <button class="prev"></button>\n                        <button class="next"></button>\n                    </div>\n                ');
                       e.children[0].addEventListener("click", (() => {
                           p(!1)
                       })), e.children[1].addEventListener("click", (() => {
                           p(!0)
                       })), e.style.width = getComputedStyle(t).width.parsed() - 1 + "px", setTimeout((() => {
                           e.style.transform = `translateY(${getComputedStyle(t).height.parsed()/2-25}px)`, e.style.display = "", e.children[0].classList.add("disappear"), o.addEventListener("scroll", (function() {
                               const t = this.scrollLeft,
                                   s = o.scrollLeft === o.scrollWidth - o.clientWidth;
                               if (0 === t) e.children[0].classList.add("disappear");
                               else if (s) e.children[1].classList.add("disappear");
                               else {
                                   const t = e.querySelectorAll("button");
                                   t && t.forEach((t => t.classList.remove("disappear")))
                               }
                           }))
                       })), t.append(e)
                   }
                   if (r) {
                       const t = function(t, e) {
                           const s = t % e;
                           return s <= e / 2 ? t - s : t + e - s
                       };
                       o.addEventListener("touchend", (function() {
                           const e = this.scrollLeft,
                               s = t(e, d);
                           o.scroll({
                               top: 0,
                               left: s,
                               behavior: "smooth"
                           })
                       }))
                   }
               }
               t.append(o), t.classList.add("active")
           }(n, e, s), i.unobserve(t.target))
       }))
   }));
   i.observe(n)
};
const specialProduct = /4d-ultrasound||vip-service||dolls-maternity/g.test(location.pathname);
let MacrobabyProduct = {
   methods: {
       toggleProductDescription: function() {},
       toggleDescription: function() {
 
       },
       appendShippingEstimate: function() {
           let t = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
               e = new Date,
               o = (i = e.getMonth() + 1, r = e.getFullYear(), new Date(r, i, 0).getDate());
           var i, r;
           e.getDate() + 3 <= o ? $(".custom-text-info.stock").after(`<span class="custom-text-info estimate-delivery"><strong>Estimate of Delivery:</strong> ${t[e.getMonth()]} ${e.getDate()+3}</span>`) : $(".custom-text-info.stock").after(`<span class="custom-text-info estimate-delivery"><strong>Estimate of Delivery:</strong> ${t[e.getMonth()+1]} ${-1*(o-32)}</span>`)
       },
       checkIfUnavailable: function() {
           $(".da-restock-notification-form").length && $(".product-block-list__item.product-block-list__item--description,.video-section, .product-block-list__item.product-block-list__item--returns, .product-block-list__item.product-block-list__item--trust,  .product-block-list__item.product-block-list__item--reviews").addClass("e-out-of-stock")
       },
       preOrderTag: function() {
           if ($(".flag-pre").length) {
               $(".product-form__add-button, .addToBabyRegistry, .quantity-selector--product .quantity-selector__value,.add-wishlist , .gift-reggie-registry-button").addClass("pre-order"), $(".custom-text-info.estimate-delivery, .custom-text-info.stock").remove();
               let t = $(".flag-pre").html().replace("AVAILABLEATTAG-", "");
               $(".custom-text-info.ships-from").html(`Available on: <strong>${t}</strong>`), $("#preorder").val(t)
           }
       },
       appendWishlistButton: function() {
           $(window).width() < 780 && $(".product-form__payment-container").after($(".gift-reggie-buttons").first())
       },
       appendVariantColors: function() {
           let t = t => {
               let e = "";
               t.map((t => {
                   let {
                       id: o,
                       title: i,
                       image: r,
                       available: s,
                       url: a,
                       tags: c
                   } = t;

                   console.log(r)
                   e += `<li class="colorVariants__variant"  data-available="${s}" data-active="${!!window.location.pathname.includes(a.replace("/^((/([^/]+){0,2}/?)/g","").replace(/\?[^\?]+$/g,""))}">\n                    <a href="${a.replace("/^((/([^/]+){0,2}/?)/g","").replace(/\?[^\?]+$/g,"")}"><img width="44" height="44" src="${r}" alt="${i}"></a>\n                   </li>`
               }));
               $(".product-block-list .card__section > hr.card__separator").after(`\n        <div class="colorVariants">\n          <div class="colorVariants__container">\n            <span class="colorVariats__title">Color: <strong>${(()=>{let e="";return t.map((t=>{let{id:o,title:i,image:r,available:s,url:a,tags:c}=t;window.location.pathname.includes(a.replace("/^((/([^/]+){0,2}/?)/g","").replace(/\?[^\?]+$/g,""))&&(e=c.filter((t=>t.includes("COLORTAG-")))[0].replace("COLORTAG-",""))})),e})()}</strong></span>\n            <ul class="colorVariants__list">\n              ${e}\n            </ul>\n          </div>\n        </div>\n        `)
           };
           $.ajax({
               url: window.location.href + ".json",
               type: "GET",
               success: e => {
                   if (void 0 !== e.product) {
                       let i = e.product.tags.split(", ").filter((t => t.includes("COLORTAG-")));
                       try {
                           i.length ? (o = i[0].replace("COLORTAG-", ""), new Promise(((t, e) => {
                               jQuery.getJSON("/search/suggest.json", {
                                   q: `COLORTAG-${o}`,
                                   resources: {
                                       type: "product",
                                       limit: 50,
                                       options: {
                                           fields: "title,product_type,variants.title,tag"
                                       }
                                   }
                               }).done((function(e) {
                                   if (e.resources.results) {
                                       let o = e.resources.results.products;
                                       t(o)
                                   } else t(!1)
                               }))
                           }))).then((e => {
                               t(e)
                           })) : console.log("[35m This product has no color variants!")
                       } catch (t) {
                           console.error(t)
                       }
                   } else console.log("errado"), console.log("[35m This product has no color variants!");
                   var o
               }
           })
       },
       productReadMore: function() {
        //   $(".card .e-product-description").after('<button class="productDescription__readMore">+ Read More</button>')
    
           $('.e-shipping-returns--title h2').on('click', function () { 
            $(this).parent(".e-shipping-returns--title").toggleClass('active');
            $(this).parent(".e-shipping-returns--title").next('.e-shipping-returns--text').slideToggle(1000);
           });

        

           $('.product-block-list__item--trust .card__header').on('click', function () { 
            $(".product-block-list__item--trust").toggleClass('active');
            $('.product-block-list__item--trust .card__section').slideToggle(1000);
           });

           
           $('.product-block-list__item--reviews .card__title').on('click', function () { 
            $(".product-block-list__item--reviews").toggleClass('active');
            $('.product-block-list__item--reviews .card__section').slideToggle(1000);
           });
           
           $('.product-block-list__item--shipping .card__title').on('click', function () { 
            $(".product-block-list__item--shippings").toggleClass('active');
            $('.product-block-list__item--shipping .card__section').slideToggle(1000);
           });

           $('.product-block-list__item--description.specs .section-title').on('click', function () { 
            $(".product-block-list__item--description.specs").toggleClass('active');
            $('.product-block-list__item--description.specs .productSpecification__table').slideToggle(1000);
           });

           

           $('.e-price-match--title h2').on('click', function () {
    var $title = $(this).closest('.e-price-match--title');
    var $text = $title.next('.e-price-match--text');

    $title.toggleClass('active');
    $text.slideToggle(1000);
});
    
        var blockDropshipping = setInterval( () => {
            if( $('.estimate-st').length ){
              if( $('#dropshippingCustom').val() == 'true' ){
                  $('.estimate-st').hide();
                  //$('.custom-text-info.ships-from').hide();
              }
              clearInterval(blockDropshipping)
            }
          })
             
        }
   },
   init: function() {
       this.methods.toggleDescription(), this.methods.productReadMore(), this.methods.checkIfUnavailable(), this.methods.preOrderTag(), this.methods.appendWishlistButton(), $("body").hasClass("template-product") && (this.methods.appendVariantColors(), $("#easyCustomField label").length && ($("#easyCustomField").attr("style", "display: block!important"), $('form[action*="/cart/add"]').attr("style", "display: block!important"), $('form[action*="/cart/add"] > *:not(#easyCustomField)').attr("style", "display: none!important"), $(".card__collapsible-button, .card__section").attr("style", "padding-bottom: 100px;display: flex;flex-direction: column;padding: 0 10px;"), $(".card.card--sticky").attr("style", "position: relative!important;top: 0!important;"), window.innerWidth < 1e3 && $(".product-meta__share-buttons").attr("style", "margin-bottom: 40px")))
   }
};

function detectMobile() {
   matchMedia("(max-width: 641px)").matches
}
$((function() {
   MacrobabyProduct.init(), $(window).width() < 800 && $(".header__action-item-content, .product-form__add-button ").on("click", (function() {
       $(".product-form__payment-container").toggle()
   })), $(".block-swatch__item .block-swatch__item-text").on("click", (function() {
       var t = $(this).html();
       $(".js--product-select option").each((function() {
           if ($(this).text().includes(t)) {
               var e = $(this).attr("value");
               $(".js--product-select option").removeAttr("selected"), $(this).attr("selected", "selected"), $(".js--product-select").val(e), $(".js--price-updated").text($(".js--product-select option[selected]").text().split(" - ")[1])
           }
       })), $.ajax({
           url: window.location.href + ".json",
           type: "GET",
           success: e => {
               const o = e.product.variants.find(((e, o) => e.title == t));
               $(".barCode").text(o.barcode)
           }
       })
   }))
})), $(window).on("resize", detectMobile), mbCarousel(".product-list--scrollable", {
   items: 5,
   responsive: {
       800: {
           items: 1
       }
   }
}), detectMobile();

if ($(window).width() < 800) {
   mbCarousel('.packages', {
       items: 3,
       arrows: true
   });

}